import { Injectable } from '@angular/core';
import {environment} from '../../../environments/environment';
import {HttpClient}from '@angular/common/http';
import { Observable } from 'rxjs';
import { Tsk5010Class } from '../../Class/TSK5010/tsk5010-class';
import { Tsk5020Class } from '../../Class/TSK5020/tsk5020-class';


@Injectable({
  providedIn: 'root'
})
export class Tsk5010Service {

    baseUrl: string=environment.baseUrl + 'tsk5010/';
    reportUrl: string=  environment.reportUrl;
    constructor(private http:HttpClient) { }
  

  GetCommonControlNames(id):Observable<any>
  {
      return this.http.get<any>(this.baseUrl+'GetCommonControlNames/'+id);
  }

  LoadControls():Observable<any>
  {
    return this.http.get<any>(this.baseUrl+'LoadControls');
  }

  GetControlNames():Observable<any>
  {
    return this.http.get<any>(this.baseUrl+'GetControlNames');
  }

  //Load saved data in to find section
  LoadFind(Tsk5020Class:Tsk5010Class):Observable<any>
  {
 
    return this.http.post<any>(this.baseUrl+'LoadFind',Tsk5020Class);
  }

  Create(Tsk5010Class:Tsk5010Class): Observable<any>
  {
    return this.http.post<any>(this.baseUrl+'Create',Tsk5010Class);
  }

  DoFind(Tsk5010Class:Tsk5010Class):Observable<any>
  {
    
    return this.http.post<any>(this.baseUrl+'doFind',Tsk5010Class);
  }

  //Delete an entry
  Delete(id):Observable<any>
  {
    return this.http.get<any>(this.baseUrl+'Delete/'+id);
  }

  LoadEmployeeProjectList(Tsk5010Class:Tsk5010Class):Observable<any>
  {
    return this.http.post<any>(this.baseUrl+'LoadEmployeeProjectList',Tsk5010Class);
  }

 Reply(Tsk5020Class:Tsk5010Class):Observable<any>
  {
    return this.http.post<any>(this.baseUrl+'Reply',Tsk5020Class);
  }
  GetReplyData(Tsk5020Class:Tsk5010Class):Observable<any>
    {
      return this.http.post<any>(this.baseUrl+'GetReplyData',Tsk5020Class);
    }

onPrintSummary(Tsk5010Class:Tsk5010Class): Observable<any>
{
  return this.http.post(this.reportUrl+'Tsk5010Controller/Tsk5010', Tsk5010Class, {responseType: 'blob'});
}

onPrintDetailedSummary(Tsk5010Class:Tsk5010Class): Observable<any>
{
  return this.http.post(this.reportUrl+'Tsk5010Controller/Tsk5010_1', Tsk5010Class, {responseType: 'blob'});
}

SendMail(Tsk5010Class:Tsk5010Class): Observable<any>
{
  return this.http.post(this.reportUrl+'Tsk5010Controller/Tsk5010_Mail', Tsk5010Class, {responseType: 'text'});
}

LoadData(Tsk5010Class:Tsk5010Class):Observable<any>
  {
    
    return this.http.post<any>(this.baseUrl+'LoadData',Tsk5010Class);
  }

  ChangeCompany(id):Observable<any>
{
  return this.http.get<any>(this.baseUrl+'ChangeCompany/'+id);
}

LoadChart(Tsk5010Class:Tsk5010Class):Observable<any>
  {
    
    return this.http.post<any>(this.baseUrl+'LoadChart',Tsk5010Class);
  }


  ChangeTaskCategory(id):Observable<any>
{
 
  return this.http.get<any>(this.baseUrl+'ChangeTaskCategory/'+id);
}
   TaskHistory(Tsk5020Class:Tsk5020Class):Observable<any>
   {
     return this.http.post<any>(this.baseUrl+'TaskHistory',Tsk5020Class);
   }

   LoadFilterData(Tsk5010Class:Tsk5010Class):Observable<any>
  {
    
    return this.http.post<any>(this.baseUrl+'LoadFilterData',Tsk5010Class);
  }

  LoadRelatedCompany(CompId):Observable<any>
  {
    return this.http.get<any>(this.baseUrl+'LoadRelatedCompany/'+CompId);
  }

}
